export default () => ({
  trigger: {
    name: 'service_selector.close_overlay',
    params: {},
  },
  config: {
    event: {
      name: 'close',
      params: {
        sub_feature: 'measurement_overlay',
      },
    },
  },
});
